// [Jake UI] - Bootstrap-compatible viewport breakpoint hook for responsive rendering
import { useState, useEffect, useRef, useCallback } from "react";

const BP_PHONE = 576;
const BP_TABLET = 768;
const BP_DESKTOP = 992;

function getBreakpoint(width) {
  if (width < BP_PHONE) return "phone";
  if (width < BP_TABLET) return "tablet";
  if (width < BP_DESKTOP) return "desktop";
  return "wide";
}

export default function useBreakpoint() {
  const [width, setWidth] = useState(() => {
    try {
      return window.innerWidth;
    } catch {
      return BP_DESKTOP;
    }
  });

  const rafRef = useRef(null);

  const handleResize = useCallback(() => {
    if (rafRef.current) return;
    rafRef.current = requestAnimationFrame(() => {
      setWidth(window.innerWidth);
      rafRef.current = null;
    });
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize, { passive: true });
    return () => {
      window.removeEventListener("resize", handleResize);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [handleResize]);

  const breakpoint = getBreakpoint(width);

  return {
    width,
    breakpoint,
    isPhone: breakpoint === "phone",
    isTablet: breakpoint === "tablet",
    isMobile: width < BP_TABLET,
    isDesktop: width >= BP_TABLET,
  };
}
